import { getAgreementTexts, getPetAgreementTexts } from "../utils/agreementTemplates";
import { kvkkAydinlatmaMetni as loginKvkkAydinlatmaMetni } from "./legalContents";

const emptyAgreementData = {
  name: "",
  lastname: "",
  tckn: "",
  address: "",
  phone: "",
  email: "",
  dailyPrice: ""
};

const kidCarUiDocuments = getAgreementTexts(emptyAgreementData).ui;
const petCarUiDocuments = getPetAgreementTexts(emptyAgreementData).ui;

const emptyDocumentHtml = `
  <div>
    <h3>MESAFELİ SATIŞ SÖZLEŞMESİ</h3>
  </div>
`;

const emptyDocumentBackend = `
MESAFELİ SATIŞ SÖZLEŞMESİ
`;

const stripHtmlForBackend = (content = "") =>
  content
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|h1|h2|h3|h4|h5|h6|li|ul|ol)>/gi, "\n")
    .replace(/<li[^>]*>/gi, "• ")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

export const loginDocuments = {
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    content: loginKvkkAydinlatmaMetni
  }
};

export const kidCarDocuments = {
  kvkk: {
    title: "Çocuk Arabası KVKK Aydınlatma Metni",
    content: kidCarUiDocuments[0]
  },
  preInfo: {
    title: "Çocuk Arabası Ön Bilgilendirme Formu",
    content: kidCarUiDocuments[1]
  },
  distanceServiceAgreement: {
    title: "Çocuk Arabası Mesafeli Hizmet Sözleşmesi",
    content: kidCarUiDocuments[2]
  },
  distanceSalesAgreement: {
    title: "Çocuk Arabası Mesafeli Satış Sözleşmesi",
    content: emptyDocumentHtml,
    backendContent: emptyDocumentBackend
  }
};

export const petCarDocuments = {
  kvkk: {
    title: "Evcil Hayvan Aracı KVKK Aydınlatma Metni",
    content: petCarUiDocuments[2]
  },
  preInfo: {
    title: "Evcil Hayvan Aracı Ön Bilgilendirme Formu",
    content: petCarUiDocuments[1]
  },
  distanceServiceAgreement: {
    title: "Evcil Hayvan Aracı Mesafeli Hizmet Sözleşmesi",
    content: petCarUiDocuments[0]
  },
  distanceSalesAgreement: {
    title: "Evcil Hayvan Aracı Mesafeli Satış Sözleşmesi",
    content: emptyDocumentHtml,
    backendContent: emptyDocumentBackend
  }
};

export const getConfirmedAgreementTexts = ({ serviceType, data }) => {
  const loginAgreementText = stripHtmlForBackend(loginDocuments.kvkk.content);

  if (serviceType === "kid-car") {
    const { backend } = getAgreementTexts(data);
    return [
      stripHtmlForBackend(backend[0]),
      stripHtmlForBackend(backend[1]),
      loginAgreementText
    ];
  }

  if (serviceType === "pet-car") {
    const { backend } = getPetAgreementTexts(data);
    return [
      stripHtmlForBackend(backend[0]),
      stripHtmlForBackend(backend[1]),
      loginAgreementText
    ];
  }

  return null;
};
